import React, { useEffect, useState } from 'react';
import { AnchorAPI } from 'modules/AnchorAPI';
import { useT } from 'i18n/hooks/useT';
import { EmailVerificationModal } from '../EmailVerificationModal';
import { InfoIcon, PendingButton } from './styles';

export function PendingEmailVerification({ userId }: { userId: number }) {
  const [isShowing, setIsShowing] = useState(false);
  const [showEmailVerificationModal, setShowEmailVerificationModal] = useState(
    false
  );
  const t = useT();

  useEffect(() => {
    AnchorAPI.fetchUserVerificationState().then(({ userVerificationState }) => {
      setIsShowing(userVerificationState === 'verifiedEmailChangeRequested');
    });
  }, []);

  return isShowing ? (
    <>
      <PendingButton
        type="button"
        onClick={() => setShowEmailVerificationModal(true)}
      >
        {t(
          'SettingsScreen.PendingEmailVerification.PendingButtonLabel',
          'PENDING',
          'Email verification pending status'
        )}
        <InfoIcon>
          {t(
            'SettingsScreen.PendingEmailVerification.InfoIconText',
            'i',
            'Information icon text'
          )}
        </InfoIcon>
      </PendingButton>
      {showEmailVerificationModal && (
        <EmailVerificationModal
          type="pending"
          onClickClose={() => {
            setShowEmailVerificationModal(false);
          }}
          onResendEmail={() => {
            AnchorAPI.resendVerificationEmail({ userId }).finally(() =>
              setShowEmailVerificationModal(false)
            );
          }}
        />
      )}
    </>
  ) : null;
}
